import { Outlet } from "react-router";
import { envPageRoutes } from "src/utils/appRoutes/appRoutes";
import { ModalRoutesContext } from "../../ModalRoutesContext";
import { useSyncSearchParamsWithStorage } from "./useAppLoader";

export const AppLoader = () => {
  // const { state } = useNavigation();
  useSyncSearchParamsWithStorage();

  /*
   *  THE BELOW CODE HAS BEEN COMMENTED OUT BECAUSE IT CAUSES ALL THE COMPONENTS TO
   *  UNMOUNT WHEN NAVIGATION STATE IS "LOADING" DUE TO QUERIES INVALIDATION WHICH CAN
   *  BE CAUSED BY APIs CACHE CONTROL
   */
  // if (state === "loading") {
  //   return <LoadingIndicator loading={true} disableBlur />;
  // }

  return (
    <ModalRoutesContext value={envPageRoutes}>
      <Outlet />
    </ModalRoutesContext>
  );
};
